import React from 'react';
import {Link} from 'react-router';

var defaultImg = require("../default.json");

var GridViewTransferAccept = React.createClass({
	handleCloneClick: function(accountSlug, slug){
		this.props.clone("open", accountSlug, slug);
	},
	handleBrowseClick: function(accountSlug, slug){
		this.props.editTheme(slug, accountSlug, this.props.type);
	},
	render: function() {
		if(this.props.themes != undefined){
	    	var themes = this.props.themes.map(function(value,index){
	    		var layoutclass = "";
	    		var accountSlug = value["name"].split("/")[0];
	      		var slug = value["name"].split("/")[1];
	    		var img = "";
		  		if(!(value["thumbnail_image"]) || value["thumbnail_image"] == "null"){
		  			img = <img src={defaultImg.GRID_IMAGE} alt="" title="" className="img-responsive" local/> ;
		  		} else{
		  			img = <img src={value["thumbnail_image"]} alt="" title="" className="img-responsive"/>;
		  		}
		  		/*if(value["type"] === "VIEWLAYOUT"){
		  			layoutclass = "one_fifth-xl one_fourth-lg one_third-md one_half theme-grid layout__library"
		  		} else {
		  			layoutclass = "one_fifth-xl one_fourth-lg one_third-md one_half theme-grid share__library"
		  		}*/
		return (
	          	<article className="one_fifth-xl one_fourth-lg one_third-md one_half theme-grid" key = {index}>
		            <div className="theme-grid__detail">
		              <figure className="theme-grid__img"> {img}
		                <div className="theme-grid--overlay"></div>
		                <div className="theme-grid__actions">
		                 	{/*<button className="btn__lg bg-white"><i className="fa fa-eye"></i> Preview</button>*/}
		                  	<Link to={{ pathname: '/details', query: {val:  value["slug"]  ,account: value["user"], lib: this.props.libName} }} className="btn__lg bg-very_light"><i className="fa fa-mail-forward"></i> Details</Link>
	                  		<button className="btn__lg bg-dark" onClick = {this.handleBrowseClick.bind(this, accountSlug, slug, value["type"])}><i className="fa fa-search"></i> Browse</button>
		                </div>
		              </figure>
		              <div className="theme-grid__title">
		                <h3>{slug}</h3>
		                <h4>by: {accountSlug}</h4>
		              </div>
		              <div className="theme-grid__buttons clearfix">
		                <button className="btn__lg bg-bright">Accept</button>
		              </div>
		            </div>
	          	</article>
        	);
		}, this);
	}
	return (
			<div>
				<div className="whole">
	          		<h4 className="filter--title">Transferred to me</h4>
	        	</div>
		        <div className="theme-container themes__grid">
		        	{themes}
		        </div>
		    </div>
		);
	}
});

export {GridViewTransferAccept};


/** WEBPACK FOOTER **
 ** ./html/components/GridViewTransferAccept.jsx
 **/